import React, { ReactElement } from 'react';

// language
import { injectIntl, IntlShape } from 'react-intl';

// redux
import { useSelector } from 'react-redux';

import { parseISO, format } from 'date-fns';

// @mui material components
import Card from "@mui/material/Card";
import Divider from '@mui/material/Divider';
import Icon from "@mui/material/Icon";

// components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import SegmentedBar from 'components/SegmentBar';

// types
import { ContainerReservationsData, } from 'types/typesRedux';

// icons
import { 
  containerIcon,
  arrowLeftIcon,
  arrowRightIcon,
} from 'assets/icons';

interface Props {
  intl: IntlShape,
  handleNextPage: () => void,
  handlePreviousPage: () => void,
}

function ReservationInContainer( { intl, handleNextPage, handlePreviousPage } :Props ): JSX.Element {

  const containerReservations = useSelector( (state: ContainerReservationsData) => state.containerReservations.containerReservations );
     
  return (
    <>
      <Card
        sx={{
          borderRadius: ({ borders: { borderRadius } }) => borderRadius.lg,
          width:"100%",
        }}
      >
        <MDBox        
          display="flex"
          flexDirection="column"
          m={0}
          sx={{
            listStyle: "none",  padding: "1rem 2rem",
          }}
        >

          {/* Header */}
          <MDBox        
            display="flex"
            flexDirection="row"
            m={0}
            sx={{
              listStyle: "none", paddingBottom:"0.6rem",
              width: "100%", justifyContent: "space-between",
            }}
          >
            <MDBox
              sx={{
                display: "flex", flexDirection: "row",
              }}
            >
              <MDBox
                className="badge"
                sx={{ 
                mt: "-2.0rem", ml: 0,
                borderRadius: ({ borders: { borderRadius } }) => borderRadius.xl, 
                backgroundColor: "#17C063",
                }}
                display="grid"
                justifyContent="center"
                alignItems="center"
                color="white"
                width="4.5rem"
                height="4.5rem"
                shadow="md"
                borderRadius="lg"
                variant="gradient"  
                fontSize= "2.2rem"
              >
                <Icon sx={{marginBottom:"0.8rem"}} >{containerIcon}</Icon>
              </MDBox>

              <MDTypography 
                variant="h5" color="#000"
                fontWeight="medium" fontSize="19px" pl="1.5rem"
              >
                {intl.formatMessage({ id: 'containerReservation.title' })}
              </MDTypography>

            </MDBox>    
          </MDBox>

          <MDBox
            sx={{
              display: "flex", flexWrap: "wrap",
              gap: "0.8rem", paddingTop: "0.4rem"
            }}
          >
            {/* Cards */}
            { containerReservations.map( (reservation, index) => {
              
              const formattedDate = format(parseISO(reservation.date), "d.M.yyyy");

              return (
                <MDBox
                  sx={{
                    width: "12.6%",
                    display: "flex", flexDirection: "row",
                  }}
                >
                  <MDBox
                    sx={{
                      display: "flex", flexDirection: "column",
                      justifyContent: "center", width: "100%",
                    }}
                  >
                    {/* Dátum */}
                    <MDTypography
                      sx={{
                        fontSize: "0.75rem", fontWeight: "400",
                        textAlign: "center",
                      }}
                    >
                      {formattedDate}
                    </MDTypography>
  
                    <MDBox
                      sx={{
                        display: "flex", flexDirection: "column",
                        alignItems: "center", border: "2px solid #ccc",
                        borderRadius: "8px", p: "0.15rem",
                        width: "100%", background: "#fff",
                      }}
                    >
                      {reservation.slots.map( (item, index) => (
                        <MDBox 
                          sx={{
                            display: "flex", flexDirection: "column",
                            alignItems: "center", marginBottom: "0.1rem",
                            width: "100%", background: "#F0EDE8",
                            borderRadius: "5px", paddingBottom: "0.15rem",
                          }}
                        >
                          <MDTypography
                            sx={{
                              fontSize: "1rem", fontWeight: "400",
                            }}
                          >
                            {`${item.boats}/8`}
                          </MDTypography>
                          <SegmentedBar total={8} filled={item.boats} />
                        </MDBox>                      
                      ))}
                    </MDBox>
                  </MDBox>
                </MDBox>                
              )
            }

            )}            
          </MDBox>

          <MDBox
            sx={{
              width: "100%",
              display: "flex", flexDirection: "row",
              justifyContent: "flex-end", gap: "0.8rem",
              paddingTop: "0.9rem",
            }}
          >
            <MDBox
              sx={{
                width: "35px", height: "35px",
                border: "1px solid #D2D6DA", borderRadius: "7px",
                cursor: "pointer",
                boxShadow: "0rem 0.1875rem 0.1875rem 0rem rgba(76, 175, 80, 0.15),0rem 0.1875rem 0.0625rem -0.125rem rgba(76, 175, 80, 0.2),0rem 0.0625rem 0.3125rem 0rem rgba(76, 175, 80, 0.15)",

                "&:hover": {
                  color: "#F0EDE8",
                  boxShadow:
                    "0rem 0.875rem 1.625rem -0.75rem rgba(76, 175, 80, 0.4)," +
                    "0rem 0.25rem 1.4375rem 0rem rgba(76, 175, 80, 0.15)," +
                    "0rem 0.5rem 0.625rem -0.3125rem rgba(76, 175, 80, 0.2)",
                },

                "&:active": {
                  opacity: "0.75",
                },
              }}
              onClick={ () => handlePreviousPage() }
            > 
              <MDBox
                sx={{
                  width: "100%", height: "100%",
                  display: "flex", flexDirection: "row",
                  justifyContent: "center", alignItems: "center",
                }}
              >
                {arrowLeftIcon}
              </MDBox>
            </MDBox>
            <MDBox
              sx={{
                width: "35px", height: "35px",
                border: "1px solid #D2D6DA", borderRadius: "7px",
                cursor: "pointer",
                boxShadow: "0rem 0.1875rem 0.1875rem 0rem rgba(76, 175, 80, 0.15),0rem 0.1875rem 0.0625rem -0.125rem rgba(76, 175, 80, 0.2),0rem 0.0625rem 0.3125rem 0rem rgba(76, 175, 80, 0.15)",

                "&:hover": {
                  color: "#F0EDE8",
                  boxShadow:
                    "0rem 0.875rem 1.625rem -0.75rem rgba(76, 175, 80, 0.4)," +
                    "0rem 0.25rem 1.4375rem 0rem rgba(76, 175, 80, 0.15)," +
                    "0rem 0.5rem 0.625rem -0.3125rem rgba(76, 175, 80, 0.2)",
                },

                "&:active": {
                  opacity: "0.75",
                },
              }}
              onClick={ () => handleNextPage() }
            >
              <MDBox
                sx={{
                  width: "100%", height: "100%",
                  display: "flex", flexDirection: "row",
                  justifyContent: "center", alignItems: "center",
                }}
              >
                {arrowRightIcon}
              </MDBox>
            </MDBox>
          </MDBox>

        </MDBox>
      </Card>
    </>

  );
}

export default injectIntl(ReservationInContainer);
